export const Menu = () => (
    <>
        <line
            x1="1"
            y1="1"
            x2="21"
            y2="1"
            stroke="#162539"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <line
            x1="1"
            y1="9"
            x2="17"
            y2="9"
            stroke="#162539"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <line
            x1="1"
            y1="17"
            x2="12"
            y2="17"
            stroke="#162539"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </>
);

Menu.viewBox = '0 0 22 18';
